<div class="container-fluid p-0">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="bento-tabset tabs-top form-group mt-3 ml-3" style="background-color: black;">
        <ul class="nav nav-pills ml-3" ngbNav #nav="ngbNav" type="pills" [orientation]="'horizontal'">
          <li ngbNavItem="a">
            <a ngbNavLink routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
              Events
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="row no-gutters">
    <div class="col-12">
      <div class="form-group mt-3 ml-3 bento-tabset tabs-top">
        <ul ngbNav #nav="ngbNav" class="nav nav-tabs">
          <li ngbNavItem>
            <a ngbNavLink
              [routerLink]="['/eventsAdmin/show-all-events', '/eventsAdmin/registration-page', '/eventsAdmin/registration-page/:id']"
              routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
              Registrations
            </a>
          </li>
          <li ngbNavItem>
            <a ngbNavLink [routerLink]="['/eventsAdmin/schema-browser']" routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: false }">
              Schema Browser
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="row no-gutters">
    <div class="col-12">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>